import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-54ad1981"), n = n(), _popScopeId(), n);
const _hoisted_1 = { id: "search-overlay-container" };
const _hoisted_2 = _withScopeId(() => _createElementVNode("hr", { class: "margin-right-scroll dashed" }, null, -1));
const _hoisted_3 = { id: "search-results-container" };
const _hoisted_4 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
            id: "search-input",
            type: "text",
            placeholder: "Enter username or callsign",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.searchInput) = $event))
        }, null, 512), [
            [_vModelText, _ctx.searchInput]
        ]),
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: result.flightId
                }, [
                    _createElementVNode("div", {
                        class: "search-result",
                        onClick: ($event) => (_ctx.onClick(result.flightId))
                    }, [
                        _createElementVNode("p", null, _toDisplayString(result.text), 1)
                    ], 8, _hoisted_4)
                ]));
            }), 128))
        ])
    ]));
}
